import * as React from 'react'
import { Radio, RadioGroup } from '@blueprintjs/core'
import { BookResult } from './types'

interface Props {
  books: BookResult[]
  setSelectedBookIndex: (index: number) => void
  selectedBookIndex: number | null
}

const AmazonBookResults: React.FC<Props> = ({ books, setSelectedBookIndex, selectedBookIndex }) => {
  return (
    <div className="amazon-book-results-container">
      <h3>Search results</h3>
      <RadioGroup
        onChange={e => setSelectedBookIndex(Number(e.currentTarget.value))}
        selectedValue={selectedBookIndex?.toString() ?? ''}
        className="amazon-book-results"
      >
        {books.map((book, index) => (
          <Radio key={book.asin || `book-${index}`} value={index.toString()} className="amazon-book-result">
            <div className="book-content">
              <img src={book.mainImageUrl} alt={book.title} className="book-image" />
              <div className="book-details">
                <div className="book-title">{book.title}</div>
                <div className="book-author">{book.author}</div>
              </div>
            </div>
          </Radio>
        ))}
      </RadioGroup>
    </div>
  )
}

export default AmazonBookResults
